// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3d625eb","311":"aa7521c3","322":"2968e644","355":"057ff083","698":"60c1b16e","732":"18c5c561"}[chunkId] + ".chunk.js";
};